<template>
  <form>
    <VTextField
      v-model="data.title"
      :label="$t('forms.labels.subject')"
      :rules="{ required: true, min: 1, max: 200 }"
      data-cy="feedback-title"
      @input="updateData"
    />
    <VTextarea
      v-model="data.message"
      :label="$t('forms.labels.message')"
      :rules="{ required: true, min: 1, max: 3000 }"
      data-cy="feedback-message"
      @input="updateData"
    />
  </form>
</template>

<script>
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextarea,
        VTextField,
    },
    data() {
        return {
            data: {
                title: null,
                message: null,
                url: window.location.href,
            },
        };
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
